import { render } from "./TiradorDadosPlay.vue?vue&type=template&id=4d06c11b"
import script from "./TiradorDadosPlay.vue?vue&type=script&lang=js"
export * from "./TiradorDadosPlay.vue?vue&type=script&lang=js"

import "./TiradorDadosPlay.vue?vue&type=style&index=0&id=4d06c11b&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__